var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNotFound)?_c('not-found',{attrs:{"text-key":'FSOrganization'}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }